import { Feature, PricingPlan } from '__generated__/GQL';
import Bolt from 'assets/brand/bolt@2x.png';
import flyingBills from 'assets/brand/flying-bills@2x.png';
import DecorativeImage from 'components/DecorativeImage';
import { SupportedFeaturePreview } from 'features/Upgrade/types';

import locales from './locales';
import { CarouselItem, CarouselItems } from './types';

export const CAROUSEL_ITEMS: Record<
  SupportedFeaturePreview,
  ({
    higherPlans,
  }: {
    higherPlans: Pick<PricingPlan, 'brandName'>[];
  }) => CarouselItems
> = {
  [Feature.BulkTransfers]: ({ higherPlans }) => {
    const firstPlansNames = higherPlans
      .slice(0, -1)
      .map(({ brandName }) => brandName)
      .join(', ');
    // @ts-expect-error Property 'brandName' does not exist on type 'Pick<PricingPlan, "brandName"> | undefined'.
    const [{ brandName: lastPlanName }] = higherPlans.slice(-1);

    return [
      {
        image: (
          <DecorativeImage heightPx={180} src={flyingBills} widthPx={180} />
        ),
        subtitle: locales.bulkTransfers.featurePreview.subtitle,
        title: locales.bulkTransfers.featurePreview.title,
      },
      {
        image: <DecorativeImage heightPx={180} src={Bolt} widthPx={216} />,
        subtitle:
          firstPlansNames.length > 1
            ? locales.formatString(
                locales.bulkTransfers.upgradeIncentive.subtitlePlural,
                { firstPlansNames, lastPlanName },
              )
            : locales.formatString(
                locales.bulkTransfers.upgradeIncentive.subtitleSingular,
                { planName: lastPlanName },
              ),
        title: locales.formatString(
          locales.bulkTransfers.upgradeIncentive.title,
          // @ts-expect-error Object is possibly 'undefined'.
          { planName: higherPlans[0].brandName },
        ),
      } as CarouselItem,
    ];
  },
};
